import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { dateFormat } from 'data/static';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useUpdateTaskDueDateMutation } from 'redux/apiSlices/tasks.slice';

type TTaskDuedateProps = {
  taskId: string;
  dueDate?: string;
};

const TaskDuedate: FC<TTaskDuedateProps> = ({ dueDate, taskId }) => {
  const [updateDueDate] = useUpdateTaskDueDateMutation();
  const onUpdateDueDate = (date: string) => {
    updateDueDate({
      taskId,
      dueDate: date,
    });
  };

  const defaultDate = dueDate ? dayjs(dueDate) : null;
  const isOverdue = dueDate && dayjs(dueDate).isBefore(dayjs(), 'day');
  const isToday = dueDate && dayjs(dueDate).isSame(dayjs(), 'day');

  return (
    <DatePicker
      value={defaultDate}
      onChange={value => {
        const dateToSave = value ? dayjs(value).format() : '';
        onUpdateDueDate(dateToSave);
      }}
      slotProps={{
        actionBar: {
          actions: ['clear', 'today'],
        },
        textField: {
          size: 'small',
          fullWidth: true,
          placeholder: 'Set due date',
          InputProps: {
            startAdornment: (
              <CalendarTodayIcon
                sx={{
                  fontSize: 18,
                  mr: 1,
                  color: isOverdue ? 'error.main' : isToday ? 'warning.main' : 'text.secondary',
                }}
              />
            ),
          },
        },
      }}
      closeOnSelect
      format={dateFormat}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'background.paper',
          '& input': {
            py: 1,
            fontSize: '0.875rem',
          },
          '& input::placeholder': {
            color: 'text.secondary',
            opacity: 1,
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'divider',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'primary.main',
        },
      }}
    />
  );
};

export default TaskDuedate;
